import type { GetStaticProps } from 'next';
import {
  fetchBlogPosts,
  fetchCaseStudies,
  fetchCaseStudyServices,
} from '../utils/api/fetchStrapiData';
import CaseStudies from '../views/caseStudies';

export const getStaticProps: GetStaticProps = async () => {
  const caseStudies = await fetchCaseStudies();
  const blogPosts = await fetchBlogPosts();
  const caseStudyServices = await fetchCaseStudyServices();

  const filteredCaseStudies = caseStudies.filter(
    (item) => item.createPage && !item.previewPassword
  );

  const data = {
    caseStudies: filteredCaseStudies,
    blogPosts,
    caseStudyServices,
  };

  return {
    props: data,
  };
};

export default CaseStudies;
